










import Vue from 'vue';
import Lottie from '../Lottie/DescoLottie.vue';
import * as animationDataV2 from '../../assets/animations/logo.v2.json';

export default Vue.extend({
  components: {
    Lottie,
  },
  props: {
    setAnimationController: {
      type: Function,
      default: () => {},
    },
    width: {
      type: Number,
      default: 90,
    },
    height: {
      type: Number,
      default: 90,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    options() {
      return {
        loop: true,
        autoplay: true,
        animationData: animationDataV2,
      };
    },
  },
});
